import EngageAccessorApi from '../../api/engageAccessor';
import { throwErrorMessage } from '../utils/api';

const state = {
  uiFlags: {
    isProcessing: false,
  },
};

export const getters = {
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  processMessage: async (
    { commit },
    { conversationId, messages, context, clear_context, images }
  ) => {
    commit('setUIFlag', { isProcessing: true });
    try {
      const response = await EngageAccessorApi.processMessage(conversationId, {
        messages,
        context,
        clear_context,
        images,
      });
      return response;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('setUIFlag', { isProcessing: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
